<template>
  <div class="channel-flow-user-form-wrapper">
    <p class="channel-flow-modal-step-description">
     {{ getTranslations("expression_1376") }}
    </p>

    <!-- Nome do Usuário -->
    <div class="channel-flow-user-form-group">
      <label for="userName" class="channel-flow-user-form-label">{{ getTranslations('expression_42') }} *</label>
      <input
        id="userName"
        v-model="new_user.name"
        type="text"
        class="channel-flow-input"
        :placeholder="getTranslations('expression_1378')"
      />
    </div>

  
<!-- E-mail do Usuário -->
<ValidationObserver ref="observer" v-slot="{ invalid }">
  <div class="channel-flow-user-form-group">
    <label for="userEmail" class="channel-flow-user-form-label">
      {{ getTranslations('expression_161') }} *
    </label>

    <ValidationProvider
  ref="emailProvider"
  name="userEmail"
  rules="required|email"
  v-slot="{ errors, valid }"
>
  <input
    id="userEmail"
    v-model="new_user.email"
    type="email"
    class="channel-flow-input"
    :placeholder=  "getTranslations('expression_1377')"
    required
  />
  <!-- Exibição do erro de validação -->
  <span v-if="emailError" class="channel-flow-user-form-error">
    {{ emailError }}
  </span>
</ValidationProvider>

  </div>
</ValidationObserver>







    <!-- Função do Usuário -->
    <div class="channel-flow-user-form-group">
      <label for="userRole" class="channel-flow-user-form-label">{{ getTranslations('expression_687') }} *</label>
      <div class="channel-flow-select-wrapper">
        <select id="userRole" v-model="new_user.role_key" class="channel-flow-select" @change="handleRoleChange">
          <option selected disabled>{{ getTranslations('expression_285') }}</option>
          <option :value="0">{{ getTranslations('expression_81') }}</option>
          <option :value="1">{{ getTranslations('expression_688') }}</option>
          <option :value="2">{{ getTranslations('expression_689') }}</option>
        </select>
      </div>
    </div>

    <!-- Explicação das funções -->
    <div v-if="new_user.role_key !== null" class="channel-flow-user-form-role-info">
      <p v-if="new_user.role_key === 0">
        <strong>{{ getTranslations('expression_81') }}:</strong> {{ getTranslations("expression_1390") }}
      </p>
      <p v-if="new_user.role_key === 1">
        <strong>{{ getTranslations('expression_688') }}:</strong> {{ getTranslations("expression_1391") }}
      </p>
      <p v-if="new_user.role_key === 2">
        <strong>{{ getTranslations('expression_689') }}:</strong> {{ getTranslations("expression_1392") }}
      </p>
    </div>

    <!-- Seleção de Equipe -->
    <div class="channel-flow-user-form-group">
      <label for="userTeam" class="channel-flow-user-form-label">
        {{ getTranslations("expression_12") }} *
        <span v-if="new_user.role_key === 2" class="channel-flow-tooltip-wrapper">
          <UilQuestionCircle class="channel-flow-tooltip-icon" />
          <span class="channel-flow-tooltip-text">
            {{ getTranslations("expression_1379") }}
          </span>
        </span>
      </label>
      <div class="channel-flow-user-form-select-wrapper">
        <select
          id="userTeam"
          v-model="new_user.department_key"
          class="channel-flow-select"
          :disabled="new_user.role_key === 2"
        >
          <option selected disabled>{{ getTranslations("expression_1380") }}</option>
          <option v-for="(team, index) in teams" :key="index" :value="index">
            {{ team.name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Botão para adicionar o usuário -->
    <button @click="emitUser" class="channel-flow-user-form-add-btn">
      {{ getTranslations('expression_690') }}
    </button>

    <!-- Lista de usuários adicionados -->
    <div v-if="localUsers.length > 0" class="channel-flow-user-list-wrapper">
      <label class="channel-flow-user-form-label">{{ getTranslations("expression_1381") }}:</label>
      <ul class="channel-flow-user-list">
        <li v-for="(user, index) in localUsers" :key="index" class="channel-flow-user-list-item">
          <div class="channel-flow-user-item-info">
            <div class="channel-flow-user-item-main">
              <span class="channel-flow-user-item-name">{{ user.name }}</span>
              <span class="channel-flow-user-item-email">{{ user.email }}</span>
            </div>
            <div class="channel-flow-user-item-details">
              <span class="channel-flow-user-item-role">
                <strong>{{ getTranslations('expression_687') }}:</strong>
                {{ parseRole(user.role_key) }}
              </span>
              <span v-if="user.role_key !== 2" class="channel-flow-user-item-team">
                <strong>{{ getTranslations("expression_12") }}:</strong>
                {{ teams[user.department_key]?.name }}
              </span>
            </div>
          </div>
          <button @click="removeUser(index)" class="channel-flow-user-item-remove-btn" :title="getTranslations('expression_1393')">
            <UilTrashAlt />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>



<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { api } from "../../../services/index";
import "../../../../js/assets/css/Channel-Flow/channel-flow.css"
import { UilQuestionCircle, UilTrashAlt } from '@iconscout/vue-unicons';

extend('required', required);
extend('email', email);

export default {
  components: {
    UilQuestionCircle,
    UilTrashAlt,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    teams: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      new_user: {
        name: "",
        email: "",
        role_key: null,
        department_key: null,
      },
      localUsers: [],
      emailError: "",
      errors: {},
    };
  },
  watch: {
  'new_user.email': function() {
    this.emailError = ""; // limpa o erro de email invalido
  }
},
  methods: {
    clearEmailError() {
      this.emailError = "";
    },
    handleRoleChange() {
      if (this.new_user.role_key === 2) {
        this.new_user.department_key = null;
      }
    },
    async validateEmail(email) {
      if (!email) return false;

      // verifica local
      const emailExistsLocally = this.localUsers.some(
        (user) => user.email === email
      );

      if (emailExistsLocally) {
        this.$toast.error( this.getTranslations("expression_1382"));
        return false;
      }

      // verifica no backend
      try {
        const { data } = await api.post("/users/verify-by-email", { email });

        if (data.exists) {
          this.$toast.error(this.getTranslations("expression_1383"));
          return false;
        }

        return true;
      } catch (error) {
        this.$toast.error(this.getTranslations("expression_1384"));
        return false;
      }
    },

    generateRandomPassword() {
      const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let password = "";
      for (let i = 0; i < 10; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return password;
    },

    async emitUser() {
  this.emailError = "";
  if (
    !this.new_user.name ||
    !this.new_user.email ||
    this.new_user.role_key === null ||
    (this.new_user.role_key !== 2 && this.new_user.department_key === null)
  ) {
    this.$toast.error(this.getTranslations("expression_1385"));
    return;
  }

  // transforma em minusculo o email
  this.new_user.email = this.new_user.email.trim().toLowerCase();

  // verifica se tem formato valido
  const isValid = await this.$refs.observer.validate();
  if (!isValid) {
    this.emailError = this.getTranslations("expression_1386");
    this.$toast.error(this.getTranslations("expression_1387"));
    return;
  }

  // Verifica a existencia do email no backend
  const emailIsValid = await this.validateEmail(this.new_user.email);

  if (emailIsValid) {
    // Adiciona o novo usuário à lista local
    this.localUsers.push({
      ...this.new_user,
      password: this.generateRandomPassword(),
    });

    // Emitir a lista de usuários atualizada para o componente pai
    this.$emit("update-users", [...this.localUsers]);

    // Exibir mensagem de sucesso
    this.$toast.success(`${this.getTranslations("expression_1394")} ${this.new_user.name} ${this.getTranslations("expression_1388")}`);


    // Limpar os campos do formulário
    this.new_user = {
      name: "",
      email: "",
      role_key: null,
      department_key: null,
    };
  }
},
  



    parseRole(role_key) {
      const roles = {
        0: "Operador",
        1: "Supervisor",
        2: "Administrador",
      };
      return roles[role_key] || "Desconhecido";
    },

      removeUser(index) {
      this.localUsers.splice(index, 1);
      this.$emit("update-users", [...this.localUsers]);
      this.$toast.success(getTranslations("expression_1389"));
    },

    parseRole(roleKey) {
      switch (roleKey) {
        case 0:
          return "Agente";
        case 1:
          return "Supervisor";
        case 2:
          return "Admin";
        default:
          return "";
      }
    },

    getTranslations(key) {
      // A lógica para obter traduções
      return key; 
    },
  },
};
</script>






